import { render } from "./MenuDay.vue?vue&type=template&id=2e65ff92"
import script from "./MenuDay.vue?vue&type=script&lang=js"
export * from "./MenuDay.vue?vue&type=script&lang=js"

import "./MenuDay.vue?vue&type=style&index=0&id=2e65ff92&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__